import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const autenticacaoInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    tap({
      next: (event) => {
        // Não precisa fazer nada com as respostas bem-sucedidas
      }, 
      error: (err) => {
        if (err.status === 401) {
          router.navigate(['/login']);
        }
      }
    })
  );
};
